export const DEFAULT_LOCATOR_STRATEGY = "default";
export const SECONDARY_LOCATOR_STRATEGY = "secondary";
